declare let WEBPACK_INLET_VERSION: string
declare let WEBPACK_INLET_NAME: string

export const getInletMetadata = () => {
  return {
    name: WEBPACK_INLET_NAME,
    version: WEBPACK_INLET_VERSION
  }
}
